"use client";

import type { MouseEvent as ReactMouseEvent } from "react";
import { RiArrowRightSLine } from "react-icons/ri";
import { cn } from "@dionatanbig2be/big2be-ui/utils";
import { Icon } from "@/shared/components/Icon";
import type { CategoryItem } from "../../types/category-panel";

interface CategoryDepartmentListProps {
    categories: CategoryItem[];
    activeId: string | null;
    /**
     * Ativa um departamento (hover ou clique). Recebe o evento porque o drawer
     * moderno precisa medir a posição do botão para alinhar o popover no eixo Y.
     */
    onActivate: (id: string, event: ReactMouseEvent<HTMLButtonElement>) => void;
    className?: string;
}

/**
 * Coluna de departamentos do desktop — a mesma nas duas variantes: sidebar do
 * mega-menu clássico e corpo do drawer moderno. Só seleciona (não navega); quem
 * exibe o conteúdo é o CategoryDetailCard ao lado.
 */
export function CategoryDepartmentList({
    categories,
    activeId,
    onActivate,
    className,
}: CategoryDepartmentListProps) {
    // A coluna do ícone só existe se algum departamento tem um: assim os nomes
    // ficam alinhados entre si, e uma loja sem ícones não ganha um recuo vazio.
    const hasIcons = categories.some((cat) => cat.icon);

    return (
        <div className={className}>
            {categories.map((cat) => (
                <button
                    key={cat.id}
                    type="button"
                    onMouseEnter={(e) => onActivate(cat.id, e)}
                    onClick={(e) => onActivate(cat.id, e)}
                    className={cn(
                        "flex w-full items-center gap-3 px-4 py-3 text-md transition-colors duration-150",
                        cat.id === activeId
                            ? "bg-primary/5 font-semibold text-primary"
                            : "text-base-content/70 hover:bg-base-200/50 hover:text-base-content"
                    )}
                >
                    {hasIcons && (
                        <span className="flex w-5 shrink-0 items-center justify-center">
                            <Icon name={cat.icon} />
                        </span>
                    )}
                    <span className="flex-1 text-left">{cat.label}</span>
                    <RiArrowRightSLine size={16} className="shrink-0 opacity-40" />
                </button>
            ))}
        </div>
    );
}
